import { Link, NavLink, Outlet } from "react-router-dom";
import Button from "../../components/ui/Button";
import StrokeTitle from "../../components/ui/StrokeTitle";
import ReactPlayer from "react-player";
import { useState } from "react";
import Modal from "../../components/ui/Modal";
import AltTitle from "../../components/ui/AltTitle";

const LevelSystem = () => {
  return (
    <>
      <div className="text-wrapper">
        <div className="page-nav">
          <NavLink to="characters">
            <Button text="Progression des personnages" color="blue"/>
          </NavLink>
          <NavLink to="reincarnation">
            <Button text="La Réincarnation" color="blue"/>
          </NavLink>
          <NavLink to="item-reincarnation">
            <Button text="La Réincarnation d'objet" color="blue"/>
          </NavLink>
          <NavLink to="basic">
            <Button text="Le système de base" color="blue"/>
          </NavLink>
          <NavLink to="character-features">
            <Button text="Les caractéristiques des personnages" color="blue"/>
          </NavLink>
          <NavLink to="netherworld">
            <Button text="Le Tourisme endiablé" color="blue"/>
          </NavLink>
        </div>
      </div>
      <Outlet/>
      <div className="text-wrapper">
        <div className="page-nav">
          <NavLink to="characters">
            <Button text="Progression des personnages" color="blue"/>
          </NavLink>
          <NavLink to="reincarnation">
            <Button text="La Réincarnation" color="blue"/>
          </NavLink>
          <NavLink to="item-reincarnation">
            <Button text="La Réincarnation d'objet" color="blue"/>
          </NavLink>
          <NavLink to="basic">
            <Button text="Le système de base" color="blue"/>
          </NavLink>
          <NavLink to="character-features">
            <Button text="Les caractéristiques des personnages" color="blue"/>
          </NavLink>
          <NavLink to="netherworld">
            <Button text="Le Tourisme endiablé" color="blue"/>
          </NavLink>
        </div>
      </div>
    </>
  )
}

const Leveling = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 11
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="level_.jpg"/>
      <StrokeTitle text="Créez les personnages communs de vos rêves !"/>
      <div className="text-wrapper">
        <p className="white-text">
        Vous découvrirez dans Disgaea 7 des guerriers cools, des jolies sorcières et des zombis pourris... au total, 45 types de personnages communs !
Ils possèdent tous une apparence distincte ainsi que leurs propres caractéristiques de combat... À vous d'en faire l'armée la plus puissante du Sous-Monde !
        </p>
      </div>
      <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_1.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 1,
            }
          )
      }}/>

      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_2.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 2,
                }
              )
          }}/>
          <h3 className="item-text white-text">
          Les Savantes: Ou comment renforcer ses alliés d'un mouvement de bras !


          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_3.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 3,
                }
              )
          }}/>
          <h3 className="item-text white-text">
          Les Voleuses: Piquer les objets de ses ennemis, c'est leur truc !
          </h3>
        </div>
      </div>

      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_4.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 4,
                }
              )
          }}/>
          <h3 className="item-text white-text">
          Les Flingueurs: Les spécialistes des armes à feu.
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_5.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 5,
                }
              )
          }}/>
          <h3 className="item-text white-text">
            Les Psychiques: La téléportation et la télékinésie n'ont aucun secret pour eux.
          </h3>
        </div>
      </div>

      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_6.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 6,
                }
              )
          }}/>
          <h3 className="item-text white-text">
            Les Prinnies: Vous n'espériez quand même pas y échapper ?!
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_7.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 7,
                }
              )
          }}/>
          <h3 className="item-text white-text">
            Sans oublier l'apparition de plein de nouveaux personnages dans Disgaea 7 !
          </h3>
        </div>
      </div>
      <StrokeTitle text="Montez l'armée la plus puissante du monde de Disgaea !"/>
      <div className="text-wrapper">
        <p className="white-text">
        Avec tous ces personnages communs disponibles, vous n'avez que l'embarras du choix pour fabriquer une armée qui vous corresponde parfaitement !

Il est bien sûr possible de n'enrôler que des filles, ou bien que des personnages tirés du monde de Hinomoto, mais aussi de monter la troupe la plus faible possible !

Le choix du concept vous appartient, faites-en bon (ou mauvais) usage !
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_8.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 8,
                }
              )
          }}/>
          <h3 className="item-text white-text">
            Magie ? Corps à corps ? Soins ? Tout à fait possible de gérer ça avec seulement des filles !
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_9.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 9,
                }
              )
          }}/>
          <h3 className="item-text white-text">
          Une troupe représentative du monde de Hinomoto, avec juste des samouraïs ou des ninjas, c'est possible aussi !
          </h3>
        </div>
      </div>   
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_10.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 10,
                }
              )
          }}/>
          <h3 className="item-text white-text">
          Quoi de plus jouissif que de tenter sa chance avec rien que des Prinnies, les personnages les plus nullos de tout le jeu ?!
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/level_11.jpg`} alt="Top-SS" onClick={()=>{
              setModal(
                {
                  ...modal,
                  'visible': true,
                  'current': 11,
                }
              )
          }}/>
          <h3 className="item-text white-text">
          En faisant évoluer vos personnages correctement, vous pourrez même en créer un méga puissant, capable de raser à lui tout seul toutes les cartes !
          </h3>
        </div>
      </div>   
    </>
  )
}

const Reincarnation = () => {

  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 3
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="rein_.jpg"/>
      <StrokeTitle text="Créez le personnage le plus puissant possible en le faisant se réincarner !"/>
      <div className="text-wrapper">
        <p className="white-text">
        La Réincarnation est un système qui va vous permettre de faire renaître un personnage en une espèce différente.
Son niveau retombera à 0, mais il conservera toutes ses Capacités apprises et ses statistiques, bref, il sera déjà bien balèze !
La Réincarnation vous permettra ainsi de peaufiner la puissance physique et magique de chacun de vos personnages !
        </p>
      </div>
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rein_1.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 1,
            }
          )
        }}/>
        <h3 className="item-text white-text">
        En réincarnant un guerrier en sorcier, cette dernière devient capable d'effectuer des combats rapprochés !
        </h3>
      </div>
      <StrokeTitle text="Tout ce qui compte, c'est l'amour !"/>
      <div className="text-wrapper">
        <p className="white-text">
        Votre personnage préféré a des statistiques vraiment faibles et ses pouvoirs ne collent pas du tout à votre troupe ? Pas d'inquiétude ! Il vous suffira de l'éduquer.
En utilisant sans modération le système de Réincarnation, vous allez pouvoir en faire un personnage polyvalent qui ne craindra plus rien !

Tout est possible dans le monde de Disgaea, même de transformer les plus nuls en bêtes de combat !
Alors on ne s'attache pas à la théorie et on fait évoluer ses petits chouchous au maximum !

        </p>
      </div>
      <div className="pair">
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rein_2.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 2,
            }
          )
        }}/>
        <h3 className="item-text white-text">
        Un petit garçon tout maigrichon au début...
        </h3>
      </div>
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/rein_3.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 3,
            }
          )
        }}/>
        <h3 className="item-text white-text">
        qui devient un sorcier aux pouvoirs surpuissants au bout de quelques réincarnations !
        </h3>
      </div>
      </div>
    </>
  )
}

const ItemReincarnation = () => {
  
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 2
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="item_.jpg"/>
      <StrokeTitle text="Un simple chewing-gum peut aussi devenir une épée légendaire !"/>
      <div className="text-wrapper">
        <p className="white-text">
        La Réincarnation d'objet est un système permettant de démultiplier la puissance d'un objet en le réincarnant en un autre objet.
Pour cela, que diriez-vous d'avoir une épée comestible avec des pouvoirs de soins ? Ou bien de vous équiper d'un bâton qui était autrefois des sandales, pour marcher plus vite ? Il n'y a plus de barrière, tout est désormais possible !

<br/>

C'est à vous que revient le choix de fabriquer l'objet de vos rêves... les possibilités sont infinies !

        </p>
      </div>
      <div className="pair">
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/item_1.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 1,
            }
          )
        }}/>
        <h3 className="item-text white-text">
          Des Capacités pas top au début...
        </h3>
      </div>
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/item_2.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 2,
            }
          )
        }}/>
        <h3 className="item-text white-text">
          mais qui s'améliorent à vue d'œil après quelques réincarnations !
        </h3>
      </div>
      </div>
      <StrokeTitle text="N'hésitez pas à abuser de ce système pour fabriquer l'arme la plus puissante du jeu !"/>
      <div className="text-wrapper">
        <p className="white-text">
        Pour résumé :      <br/>
        </p>
        <p className="white-text" style={{marginTop: '25px'}}>
          1ère génération <br/>
          Vous désirez allez plus vite avec de simples [lunettes] ? Réincarnez-les en [chaussures] !!
        </p>
        <p className="white-text"  style={{marginTop: '25px'}}>
          2ème génération – Vous obtenez des chaussures qui augmente votre PCS ! Mais vous désirez une puissante arme… Donc vous les réincarnez en [lance] !
        </p>
        <p className="white-text"  style={{marginTop: '25px'}}>
          3ème génération – Vous avez désormais une [lance] avec une PCS et une VIT élevées ! 
        </p>
        <p className="white-text"  style={{marginTop: '25px'}}>
          4ème génération – Répétez le processus… Et vous pourrez même avoir une [épée] qui améliore votre PCS, votre VIT et capable d’utiliser les capacités des lances !  
        </p>
      </div>
      <Link to="../basic">
        <Button text="Le Monde des Objets" color="blue"/>
      </Link>
    </>
  )
}

const LevelBasic = () => {
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 5
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="lb_.jpg"/>
      <StrokeTitle text="Des objets partout et dans tous les sens, du bout de biceps en passant par l'amulette de souvenir, il y en a pour tous les goûts !"/>
      <div className="text-wrapper">
        <p className="white-text">
        De nombreux objets sont disponibles dans Disgaea. Pas seulement des armes, mais aussi des articles à équiper qui possèdent tous des caractéristiques spécifiques différentes suivant la personne qui l'utilise.

Un peu de [muscles] pour augmenter vos PV lorsque vous vous sentez faiblichon ? Des [sandales] pour marcher un peu plus vite ? À vous de choisir l'objet de vos rêves !
        </p>
      </div>
      <div className="text-wrapper">
        <p className="white-text">
        Résumé   <br/>
          
Pour aller partout partout !
        </p>
        <p className="white-text" style={{marginTop: '25px'}}>
          
        Une voleuse ne peut se déplacer que sur une superficie de 6 cases… mais avec de bonnes [chaussures] aux pieds…

        </p>
        <p className="white-text"  style={{marginTop: '25px'}}>
          Et hop ! Elle pourra se déplacer plus loin !
        </p>
        <p className="white-text"  style={{marginTop: '25px'}}>
          En enfilant une paire de [chaussures], il devient possible d'augmenter la distance parcourable sur une carte ainsi que la puissance des sauts !
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/lb_1.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 1,
              }
            )
          }}/>
          <h3 className="item-text white-text">
          Il est possible d'équiper chaque personnage jusqu'à trois objets en plus de ses propres armes.
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/lb_2.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 2,
              }
            )
          }}/>
          <h3 className="item-text white-text">
          Avec des [muscles], les PV augmentent et le personnage devient plus résistant aux attaques !
Même plus mal !
          </h3>
        </div>
      </div>
      <StrokeTitle text="Achevez les niveaux des Mondes des Objets pour rendre vos objets plus puissants !"/>
      <div className="text-wrapper">
        <p className="white-text">
          Le Monde des Objets est un système permettant de renforcer vos objets une fois les donjons présents à l'intérieur achevés !
          Ces donjons changent à chaque fois, pas possible de s'ennuyer ! <br/>

          Les ennemis se trouvant à l'intérieur des objets sont proportionnellement forts à la rareté des objets. Bref, mieux vaut bien vous préparer avant de rentrer dans un objet rare si vous ne voulez pas vous faire éclater en deux secondes !
          Les cartes dont différentes de celles que vous croisez dans le jeu, n'hésitez pas à les terminer pour rendre vos objets encore plus puissants !
        </p>
      </div>
      <div className="item">
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/lb_3.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 3,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Les objets sont habités par des personnages appelés des «Innocents». <br/>
            Éliminez-les et terminez les niveaux pour rendre votre objet ENCORE plus résistant !
          </h3>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/lb_4.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 4,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Des ennemis méga balèzes dans les objets rares...
            Mieux vaut bien se préparer avant de pénétrer à l'intérieur.
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/lb_5.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 5,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Vous tomberez également sur des salles mystérieuses durant votre périple... À vous les objets super rares ?!
          </h3>
        </div>
      </div>
    </>
  )
}

const CharacterFeatures = () => {
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 5
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="ct_.jpg"/>
      <StrokeTitle text="Voyons voir les spécificités des personnages pour commencer !?"/>
      <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ct_1.jpg`} alt="Top-SS" onClick={()=>{
        setModal(
          {
            ...modal,
            'visible': true,
            'current': 1,
          }
        )
      }}/>
      <div className="text-wrapper">
        <p className="white-text">
        Chaque personnage possède une façon favorite de se battre parmi les attaques physiques, magiques ou de soutien.
Premier conseil : créez des personnages en tirant avantage de leurs points forts !
        </p>
      </div>
      <StrokeTitle text="Les Maléfices et les Mégaléfices"/>
      <div className="text-wrapper">
        <AltTitle text="Qu'est-ce qu'un Maléfice ?"/>
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ct_2.jpg`} alt="Top-SS" onClick={()=>{
        setModal(
          {
            ...modal,
            'visible': true,
            'current': 2,
          }
        )
      }}/>
        <p className="white-text">
          Chaque personnage possède des pouvoirs spéciaux.
          Parmi eux, les « Maléfices uniques », interchangeables contre des « Maléfices communs ».
        </p>
        <AltTitle text="Et un Mégaléfice alors ?"/>
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/ct_3.jpg`} alt="Top-SS" onClick={()=>{
        setModal(
          {
            ...modal,
            'visible': true,
            'current': 3,
          }
        )
      }}/>
        <p className="white-text">
          Il peut s'activer lorsque un personnage passe en mode Mégamax.
Les effets de l'attaque du personnage touchent alors absolument tous les autres personnages sur la carte, alliés ou ennemis.
        </p>
      </div>
    </>
  )
}

const NetherworldSightseeing = () => {
  const [modal, setModal] = useState({
    visible: false,
    current: 0,
    url: "",
    size: 18
  })

  return (
    <>
      <Modal modal={modal} setModal={setModal} url="sight_.jpg"/>
      <StrokeTitle text="Le Tourisme endiablé"/>
      <div className="text-wrapper">
        <p className="white-text">
        La province de Hinomoto est réputée dans tout le Sous-Monde pour ses somptueux bâtiments remplis d'histoire et sa culture toute particulière.
Allez y faire un tour et profitez du paysage et de l'ambiance !
Une fois l'histoire terminée, vous pourrez jouer à divers jeux et découvrir de nouveaux aspects de Disgaea 7 !
        </p>
      </div>
      <div className="item">
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_1.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 1,
            }
          )
        }}/>
        <h3 className="item-text white-text">
        Allez vous adresser à la Guide dimensionnelle pour commencer votre voyage !
        </h3>
      </div>
      <StrokeTitle text="Conversations originales"/>
      <div className="pair">
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_2.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 2,
            }
          )
        }}/>
      </div>
      <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_3.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 3,
            }
          )
        }}/>
      </div>
      <div className="text-wrapper">
        <p className="white-text">
        Adressez-vous aux habitants des différents Sous-Mondes de Hinomoto et découvrez une nouvelle facette de la province.
        </p>
      </div>
      <StrokeTitle text="Personnages supplémentaires"/>
      <div className="item">
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_4.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 4,
            }
          )
        }}/>
      </div>
      <div className="text-wrapper">
        <p className="white-text">
        Vous allez pouvoir croiser des personnages que vous n'avez jamais rencontrés ailleurs.
Battez-les pour en faire vos alliés !
        </p>
      </div>
      <StrokeTitle text="Quêtes spéciales"/>
      <div className="item">
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_5.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 5,
            }
          )
        }}/>
      </div>
      <div className="text-wrapper">
        <p className="white-text">
        Vous allez trouver sur votre route des tas de gens qui vont probablement vous demander de leur venir en aide, contre des récompenses bien entendu. N'hésitez pas à leur porter secours.
        </p>
      </div>
      <div className="pair">
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_6.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 6,
            }
          )
        }}/>
        <h3 className="item-text white-text">
        Vérifiez le contenu des quêtes que vous proposent les habitants que vous croisez.
        </h3>
      </div>
      <div className="item">
        <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_7.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 7,
            }
          )
        }}/>
        <h3 className="item-text white-text">
        Vous pourrez récupérer de nombreuses récompenses en accomplissant ces quêtes.
        </h3>
      </div>
    </div>
    <StrokeTitle text="L'Armurerie et les coffres" />
      <div className="item">
        <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_8.jpg`} alt="Top-SS" onClick={()=>{
          setModal(
            {
              ...modal,
              'visible': true,
              'current': 8,
            }
          )
        }}/>
        <h3 className="item-text white-text">
        Vous croiserez aussi des armureries un peu partout sur votre parcours, profitez-en pour faire quelques achats sympathiques !
        </h3>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_9.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 9,
              }
            )
          }}/>
          <h3 className="item-text white-text">
            Ces boutiques vendent parfois des objets que vous ne trouverez nulle part ailleurs.
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_10.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 10,
              }
            )
          }}/>
          <h3 className="item-text white-text">
          N'oubliez pas non plus d'ouvrir les coffres que vous trouverez ici et là sur votre chemin !
          </h3>
        </div>
      </div>
      <StrokeTitle text="Les mini-jeux des Sous-Mondes de Hinomoto"/>
      <div className="text-wrapper">
        <p className="white-text">
        Quoi, il est possible de jouer à des mini-jeux dans les Sous-Mondes de Hinomoto ?

Eh oui ! Que diriez-vous d'une petite partie de « Tsumeshogi satanique » ou bien encore de participer au « Grand Tournoi martial de Hinomoto » ?

Pas de limitations ni de contraintes pour y jouer, profitez-en !
        </p>
      </div>
      <StrokeTitle text="Le Tsumeshogi satanique"/>
      <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_11.jpg`} alt="Top-SS" onClick={()=>{
        setModal(
          {
            ...modal,
            'visible': true,
            'current': 11,
          }
        )
      }}/>
      <div className="text-wrapper">
        <p className="white-text">  
        Le Tsumeshogi satanique est un mini-jeu utilisant l'Intelligence Maléficielle et les Démonicodes.
Éditez les Démonicodes de vos alliés sur la carte et faites en sorte de la terminer le plus rapidement possible !
Vous gagnerez des prix proportionnels au nombre de tours utilisés pour remporter votre partie !
        </p>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_12.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 12,
              }
            )
          }}/>
          <h3 className="item-text white-text">
          La technique la plus efficace pour éliminer un Prinny trop éloigné... ?
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_13.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 13,
              }
            )
          }}/>
          <h3 className="item-text white-text">
          Plus la difficulté augmente et plus vous allez avoir besoin de Démonicodes compliqués.
Bon courage, on compte tous sur vous pour devenir le Master des Démonicodes et terminer tous les niveaux !
          </h3>
        </div>
      </div>
      <div className="pair">
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_14.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 14,
              }
            )
          }}/>
          <h3 className="item-text white-text">
          Vous pouvez bien sûr éditer à tout moment vos Démonicodes, sans pénalité aucune !
          </h3>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_15.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 15,
              }
            )
          }}/>
          <h3 className="item-text white-text">
          Les solutions sont multiples, à vous de trouver les plus efficaces !
          </h3>
        </div>
      </div>
      <StrokeTitle text="Pour l'honneur de devenir le guerrier le plus puissant !"/>
      <div className="item">
          <img className="large-ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_16.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 16,
              }
            )
          }}/>
        </div>
      <div className="text-wrapper">
        <p className="white-text">
        Bienvenue dans le tournoi de Hinomoto, dans lequel huit équipes vont s'affronter !
Remportez la victoire face aux autres participants et récupérez de nombreux prix rares !
        </p>
      </div>
      <div className="pair">
      <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_17.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 17,
              }
            )
          }}/>
        </div>
        <div className="item">
          <img className="ss ss-system" src={`${process.env.PUBLIC_URL}/img/ss/sight_18.jpg`} alt="Top-SS" onClick={()=>{
            setModal(
              {
                ...modal,
                'visible': true,
                'current': 18,
              }
            )
          }}/>
        </div>
      </div>
    </>
  )
}

export default LevelSystem;
export {
  Leveling, Reincarnation, ItemReincarnation, LevelBasic, CharacterFeatures, NetherworldSightseeing
};